import { render, staticRenderFns } from "./DynPage.vue?vue&type=template&id=22fbb482&"
import script from "./DynPage.vue?vue&type=script&lang=js&"
export * from "./DynPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports